"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCitationOutputDtoSchema = exports.citationSchema = exports.citationEvidenceSchema = exports.boundingBoxSchema = exports.getCitationInputDtoSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = __importStar(require("zod"));
exports.getCitationInputDtoSchema = z.object({
    fileId: z.string().optional(),
    claim: z.string().optional(),
});
const colorSchema = z.object({
    r: z.number().describe('red'),
    g: z.number().describe('green'),
    b: z.number().describe('blue'),
});
exports.boundingBoxSchema = sigma_engine_shared_1.boundingBoxSchema
    .extend({
    color: colorSchema.optional().describe('The color of the bounding box'),
})
    .strict();
exports.citationEvidenceSchema = z.object({
    information: z.string().describe('The information contained within the bounding box'),
    fileId: z.string().describe('The file ID of the PDF the evidence is in'),
    page: z.number().int().positive().describe('The page number of the page the evidence is on'),
    boundingBox: exports.boundingBoxSchema.describe('The bounding box containing the evidence'),
    contextBox: exports.boundingBoxSchema.describe('The bounding box containing the context for the evidence').optional(),
});
exports.citationSchema = z.object({
    claim: z.string().describe('The claim that the evidence supports'),
    evidence: z.array(exports.citationEvidenceSchema).describe('The list of evidence that supports the claim'),
    reasoning: z.string().describe('The reasoning for why the evidence supports the claim'),
});
exports.getCitationOutputDtoSchema = z.object({
    citation: exports.citationSchema.nullable(),
});
//# sourceMappingURL=get-citation.dto.js.map